// extracted by mini-css-extract-plugin
export var container = "_56-1";
export var cornerButtonContainer = "_56-6";
export var disabled = "_56-2";
export var dragActive = "_56-3";
export var fileContainer = "_56-5";
export var hiddenInput = "_56-4";
export var widthContainer = "_56-0";